import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { ReUnixCron } from '@sbzen/re-cron';
import React, { FunctionComponent, PropsWithChildren } from 'react';

// default schedule to top of every hour
const DEFAULT_SCHEDULE = "0 0 * * * *"

// each macro maps to its equivalent cron expressions (5- and 6-field forms);
// macros themselves aren't valid cron expressions. The first equivalent is the
// canonical form used to seed the custom cron editor.
const MACRO_SCHEDULES: Record<string, string[]> = {
    "@hourly": ["0 * * * *", "0 0 * * * *"],
    "@daily": ["0 0 * * *", "0 0 0 * * *"],
}

// the macro a schedule maps to — the macro itself or any equivalent — or
// undefined when it's a custom expression
export const toMacro = (schedule: string): string | undefined =>
    Object.keys(MACRO_SCHEDULES).find(macro =>
        macro === schedule || MACRO_SCHEDULES[macro].includes(schedule))

// macros can't be parsed by the cron editor, so resolve them to their
// canonical equivalent before seeding it
const resolveSchedule = (schedule: string) => MACRO_SCHEDULES[schedule]?.[0] ?? schedule

const scheduleWithoutSeconds = (schedule: string) => {
    const parts = schedule.split(/\s+/)
    return parts.length == 6 ? parts.slice(1).join(" ") : schedule
}

const DataScheduleComponent: FunctionComponent<any> = (props: PropsWithChildren<any>) => {
    const { selectedSchedule, onChangeSchedule, schedule, handleScheduleChange } = props

    const theScheduleValue = (() => {
        if (selectedSchedule)
            return selectedSchedule

        if (!schedule)
            return 'manual-schedule'

        return toMacro(schedule) ?? 'custom-schedule'
    })()

    return (
        <>
            <FormControl component="fieldset">
                <RadioGroup
                  aria-label="Schedule"
                  name="schedule"
                  onChange={onChangeSchedule}
                  value={theScheduleValue}
                >
                    <FormControlLabel
                        value="manual-schedule"
                        control={<Radio />}
                        label="Manual"
                    />
                    <FormControlLabel value="@hourly" control={<Radio />} label="Hourly" />
                    <FormControlLabel value="@daily" control={<Radio />} label="Daily" />
                    <FormControlLabel
                        value="custom-schedule"
                        control={<Radio />}
                        label="Custom"
                    />
                </RadioGroup>
            </FormControl>
            {theScheduleValue == "custom-schedule" ? (
                <div data-testid="cron-input">
                    <ReUnixCron
                      onChange={handleScheduleChange}
                      value={scheduleWithoutSeconds(schedule ? resolveSchedule(schedule) : DEFAULT_SCHEDULE)}
                    />
                </div>
            ) : null}
        </>
    );
};

export default DataScheduleComponent;
